import { createRootRoute, createRoute, createRouter, Outlet } from "@tanstack/react-router";
import { Shell, Pagina, Vazio } from "../shell/Shell.js";
import { Painel } from "../telas/Painel.js";
import { Reunioes } from "../telas/Reunioes.js";
import { Reuniao } from "../telas/Reuniao.js";
import { Aprovacoes } from "../telas/Aprovacoes.js";
import { Pendencias } from "../telas/Pendencias.js";
import { Configuracoes } from "../telas/Configuracoes.js";
import { ConfigPonte } from "../telas/ConfigPonte.js";
import { ConfigEquipe } from "../telas/ConfigEquipe.js";
import { Gestao } from "../telas/Gestao.js";
import { Perguntar } from "../telas/Perguntar.js";
import { Seguranca } from "../telas/Seguranca.js";
import { Gravar } from "../telas/Gravar.js";
import { Ligacoes } from "../telas/Ligacoes.js";
import { Integracoes } from "../telas/Integracoes.js";
import { Planos } from "../telas/Planos.js";

const raiz = createRootRoute({
  component: () => <Shell><Outlet /></Shell>,
  notFoundComponent: () => (
    <Pagina titulo="Página não encontrada">
      <Vazio titulo="Esta tela não existe" descricao="Confira o endereço ou volte pelo menu à esquerda." />
    </Pagina>
  ),
});

const rota = (path: string, component: () => React.JSX.Element) =>
  createRoute({ getParentRoute: () => raiz, path, component });

export const router = createRouter({
  routeTree: raiz.addChildren([
    rota("/", Painel),
    rota("/reunioes", Reunioes),
    createRoute({ getParentRoute: () => raiz, path: "/reunioes/$id", component: Reuniao }),
    rota("/pendencias", Pendencias),
    rota("/aprovacoes", Aprovacoes),
    rota("/equipe", Gestao),
    rota("/perguntar", Perguntar),
    rota("/seguranca", Seguranca),
    rota("/gravar", Gravar),
    rota("/ligacoes", Ligacoes),
    rota("/integracoes", Integracoes),
    rota("/configuracoes", Configuracoes),
    rota("/configuracoes/ponte", ConfigPonte),
    rota("/configuracoes/equipe", ConfigEquipe),
  ]),
});

declare module "@tanstack/react-router" { interface Register { router: typeof router } }
